import templateStr from 'text!./templates/back-button.html';
import 'portalConfig';

export default (function () {
    return {
        restrict: 'A',
        template: templateStr,
        scope: {
            title: '@'
        },
        controller: ['$scope', function ($scope) {
            $scope.goBack = function () {
                history.back();
            };
        }]
    };
});


//////////////////
// WEBPACK FOOTER
// ./common/js/src/edge/gateway/directives/BackButton.js
// module id = 1728
// module chunks = 0